import React from 'react';
import { Modal, Button, Stack, Group, NumberInput, Text } from '@mantine/core';
import { useForm } from '@mantine/form';

const EditRateModal = ({ opened, onClose, user, onSubmit, isSubmitting }) => {
  const form = useForm({
    initialValues: {
      amount: user?.income?.amount ?? '',
    },
    validate: {
      amount: (value) => {
        if (!value) return 'Hourly rate is required';
        return value > 0 ? null : 'Hourly rate must be greater than 0';
      },
    },
  });

  // Keep the input in sync when a different user is selected.
  React.useEffect(() => {
    if (opened) {
      form.setValues({ amount: user?.income?.amount ?? '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened, user]);

  const handleSubmit = (values) => {
    onSubmit(Math.ceil(values.amount));
  };

  const currency = user?.income?.currency || 'USD';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Edit Hourly Rate"
      size="sm"
      centered
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack gap="md">
          {user && (
            <Text size="sm" c="dimmed">
              {user.first_name} {user.last_name} ({user.email})
            </Text>
          )}

          <NumberInput
            label={`Hourly Rate (${currency})`}
            placeholder="50"
            min={0}
            required
            thousandSeparator=","
            prefix="$"
            {...form.getInputProps('amount')}
          />

          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button type="submit" variant="filled" loading={isSubmitting}>
              Save
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default EditRateModal;
